export default __webpack_public_path__ + "media/images/blue_heart_sprite_-e99abbe37aa315699dd2ccd9e498363c.png";